document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('[data-track-source="true"]');

    buttons.forEach(btn => {
        const baseUrl = btn.getAttribute('href');
        if (!baseUrl || baseUrl === '#') return;

        // Get the last part of the URL path (e.g., "conferences")
        const path = window.location.pathname
            .replace(/\/$/, '')          // remove trailing slash
            .split('/')                  // split into segments
            .filter(Boolean);            // remove empty items

        const lastSegment = path[path.length - 1] || '';

        const separator = baseUrl.includes('?') ? '&' : '?';
        btn.href = `${baseUrl}${separator}source=${encodeURIComponent(lastSegment)}`;
    });
});